import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth, useLanguage } from '../App';
import { profileAPI } from '../lib/api';
import { t } from '../lib/i18n';
import { toast } from 'sonner';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Inbox, ArrowRight } from 'lucide-react';
import { ProfileCard } from '../components/settings/ProfileCard';
import { LanguageCard } from '../components/settings/LanguageCard';
import { RemindersCard } from '../components/settings/RemindersCard';
import { SupportCard } from '../components/settings/SupportCard';

export default function SettingsPage() {
  const { user, updateUser } = useAuth();
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();

  const handleLanguageChange = async (newLang) => {
    try {
      await profileAPI.updateLanguage(newLang);
      setLanguage(newLang);
      updateUser({ language: newLang });
      toast.success(newLang === 'fr' ? 'Langue mise \u00e0 jour' : 'Language updated');
    } catch (err) {
      toast.error('Error updating language');
    }
  };

  return (
    <div className="px-4 sm:px-6 lg:px-8 py-6 space-y-6 max-w-3xl" data-testid="settings-page">
      <div className="fade-in">
        <h1 className="font-display text-3xl text-white">{t('settings', language)}</h1>
        <p className="text-white/50 text-sm mt-1">
          {language === 'fr' ? 'G\u00e9rez vos pr\u00e9f\u00e9rences' : 'Manage your preferences'}
        </p>
      </div>

      <ProfileCard user={user} language={language} />
      <LanguageCard language={language} onChange={handleLanguageChange} />
      <RemindersCard language={language} />
      <SupportCard user={user} language={language} />
      {user?.is_admin && (
        <Card className="bg-lux-panel/90 border-lux-gold/20" data-testid="settings-admin-card">
          <CardContent className="py-4 flex items-center justify-between gap-3 flex-wrap">
            <div className="flex items-center gap-3">
              <div className="p-2 rounded-lg bg-lux-gold/10"><Inbox className="w-5 h-5 text-[var(--lux-gold)]" /></div>
              <div>
                <p className="text-sm font-semibold text-white">{t('adminInbox', language)}</p>
                <p className="text-xs text-white/40">{t('adminInboxSubtitle', language)}</p>
              </div>
            </div>
            <Button data-testid="settings-admin-inbox-button" onClick={() => navigate('/admin/support')} className="bg-[var(--lux-gold)] text-[var(--lux-ink)] hover:bg-[var(--lux-gold-2)]">
              {language === 'fr' ? 'Ouvrir' : 'Open'} <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </CardContent>
        </Card>
      )}
    </div>
  );
}
